export function registerSW() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  const notify = (reg) => window.dispatchEvent(new CustomEvent('k9swupdate', { detail: reg }));

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      if (reg.waiting && navigator.serviceWorker.controller) notify(reg);
      reg.addEventListener('updatefound', () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener('statechange', () => {
          if (nw.state === 'installed' && navigator.serviceWorker.controller) notify(reg);
        });
      });
    }).catch(() => {});

    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

export function applyUpdate(reg) {
  const w = reg && reg.waiting;
  if (w) w.postMessage('SKIP_WAITING');
}
